/* eslint-disable react/prop-types */
import { Box, Paper } from "@mui/material";
import MuiPagination from "@mui/material/Pagination";
import { styled } from "@mui/material/styles";
import React from "react";
import { css } from "aphrodite";
import ArrowIcon from "../../../../assets/svg/Arrow";
import { Constants } from "../../../../contants";
import { styles } from "./Pagination.styles";
import Style from "./PaginationForMobile.styles";

const PRIMARY_COLOR = "#183053";

const PaginationWrapper = styled(MuiPagination)({
  "& .MuiPaginationItem-text": {
    color: PRIMARY_COLOR,
    fontWeight: 500,
    fontSize: 14,
  },
  "& .Mui-selected": {
    color: "#fff",
    backgroundColor: `${PRIMARY_COLOR} !important`,
  },
});

function PaginationForMobile({
  totalPages,
  currentPage,
  totalResults,
  pageSize,
  onChange,
  onPageSizeClick,
}) {
  return (
    <Paper elevation={3} className={css(Style.containerStyle)}>
      <PaginationWrapper
        count={totalPages}
        size="large"
        shape="rounded"
        page={currentPage + 1} // page value start from 0
        onChange={(_e, number) => onChange(number - 1)}
        siblingCount={0}
      />
      <Box className={css(Style.rightStyle)}>
        <span style={styles.text}>Show:</span>
        <Box style={styles.pageSize}>
          <span style={styles.text}>{pageSize} Rows</span>
          <Box style={styles.arrow}>
            <ArrowIcon
              style={{
                ...styles.upArrowIcon,
                ...(pageSize >= Constants.MAX_PAGE_SIZE ||
                pageSize * (currentPage + 1) >= totalResults
                  ? styles.disabled
                  : {}),
              }}
              onClick={() => onPageSizeClick("plus")}
            />
            <ArrowIcon
              style={{
                ...styles.downArrowIcon,
                ...(pageSize <= Constants.MIN_PAGE_SIZE ? styles.disabled : {}),
              }}
              onClick={() => onPageSizeClick("subtract")}
            />
          </Box>
        </Box>
      </Box>
    </Paper>
  );
}

export default PaginationForMobile;
